import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

class SentryClient {
  static enableSentry() {
    const { VUE_APP_SENTRY_DSN, NODE_ENV } = process.env;

    Sentry.init({
      Vue,
      dsn: VUE_APP_SENTRY_DSN,
      tracesSampleRate: NODE_ENV === 'production' ? 0.1 : 1.0,
      environment: NODE_ENV,
      integrations: [new Integrations.BrowserTracing()],
    });
  }

  static captureError(error: Error) {
    Sentry.captureException(error);
  }
}

export default SentryClient;
